/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { GoogleGenAI, Chat, GenerateContentResponse } from "@google/genai";

const API_KEY = process.env.API_KEY || '';

let chatSession: Chat | null = null;

export const initializeChat = (): Chat => {
  if (chatSession) return chatSession;

  const ai = new GoogleGenAI({ apiKey: API_KEY });
  
  chatSession = ai.chats.create({
    model: 'gemini-2.5-flash-lite',
    config: {
      systemInstruction: `Eres el asistente virtual de 'CHIMELISART', la galería de arte digital del artista Francesc Chimelis.
      
      Contexto:
      - Artista: Francesc Chimelis, pintor contemporáneo.
      - Estilo: Abstracto, Técnica Mixta, Expresionismo.
      - Ubicación: Barcelona (Galería Virtual).
      - Obras destacadas: Materia Viva, Serie Cromática, Fragmentos.
      - Servicios: Venta de originales, láminas de edición limitada y encargos personalizados.
      
      Tono:
      - Serio, profesional, sofisticado y culto. 
      - Evita cualquier lenguaje infantil, "kawaii" o excesivamente informal.
      - Eres la voz digital de Francesc Chimelis: amable pero con la autoridad de un artista consagrado.
      - Habla en ESPAÑOL por defecto, pero responde en inglés si el usuario lo hace.
      - Usa emojis de forma mínima y elegante: ✨, 🖼️.
      
      Objetivo:
      - Responder dudas sobre la técnica, concepto artístico, precios y envíos.
      - Mantén las respuestas breves, inspiradoras y con un léxico artístico elevado.
      - No uses un lenguaje excesivamente comercial; prioriza el valor artístico.`,
    },
  });

  return chatSession;
};

export const sendMessageToGemini = async (message: string): Promise<string> => {
  if (!API_KEY) {
    return "Sistemas offline. (Falta API Key)";
  }

  try {
    const chat = initializeChat();
    const response: GenerateContentResponse = await chat.sendMessage({ message });
    return response.text || "No se pudo obtener respuesta.";
  } catch (error: any) {
    console.error("Gemini Error:", error);
    // Provide more specific feedback if possible
    if (error?.message?.includes("Quota exceeded")) {
      return "Límite de mensajes alcanzado. Inténtalo más tarde. ✨";
    }
    if (error?.message?.includes("API key not valid")) {
      return "Configuración pendiente. (Error de API Key)";
    }
    return "Lo siento, ha ocurrido un error de conexión. Verifica tu conexión o intenta más tarde.";
  }
};